var exports = {
  "e6": "TransferOwnershipModal.module__warningBox___bEpGS3",
  "i4": "TransferOwnershipModal.module__warningText___bEpGS3",
};

module.exports = exports;
